import { useState, useCallback, useContext } from "react";
import { useCookies } from "react-cookie";
import { CookieContext } from "./CookieContext";

const DEFAULT_COOKIE_OPTIONS = Object.freeze({
  path: "/",
  domain: window.location.hostname,
  secure: location.protocol === "https:",
});

export function useOAuthAccessTokenCookie() {
  return useCookie("oauth-access-token");
}

export function useToken() {
  console.log("<useToken>");
  const [
    oauthAccessToken,
    setOAuthAccessTokenCookie,
    removeOAuthAccessTokenCookie,
  ] = useOAuthAccessTokenCookie();

  const getToken = () => {
    const oAuthData = oauthAccessToken
      ? oauthAccessToken
      : { token: null, authenticated: false, user: null, exp: null, sessionId: null };
    //Todo : Check expire time
    console.log("getToken!!!" + oAuthData.authenticated);

    return oAuthData;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (oAuthData) => {
    // console.log("saveToken!!!" + oAuthData.authenticated);
  
    const cookieExpiresTime = new Date(Date.now() + 2592000);
    const cookieSettings = {
      expires: cookieExpiresTime,
    };

    setOAuthAccessTokenCookie(oAuthData, cookieSettings);
    // console.log("<<saveToken!!!>>" + oAuthData.token);
    setToken(oAuthData);
  };

  const resetToken = () => {
    removeOAuthAccessTokenCookie();
    // Directly put initial object to immediately reflct change
    setToken({ token: null, authenticated: false, user: null, exp: null, sessionId: null });
  };

  const isLoggedIn = () => {
    var isLoggedIn = false;
    const current = new Date().getTime();
    const oAuthData = oauthAccessToken
      ? oauthAccessToken
      : { token: null, authenticated: false, user: null, exp: null, sessionId: null };

    //Todo : Check expire time
    if (oAuthData && current > oAuthData.exp * 1000) {
      console.log("Token Expired => ", current, oAuthData.exp);
      isLoggedIn = false;
    } else {
      console.log("Token Valid => ", oAuthData.authenticated, oAuthData.exp);
      isLoggedIn = true;
    }

    return isLoggedIn;
  };

  return {
    setToken: saveToken,
    deleteToken: resetToken,
    token,
    isLoggedIn,
  };
}

export function useCookie(cookieName) {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookie must be used within a CookieProvider");
  }

  const { cookies, setCookie, removeCookie } = context;

  return [
    cookies[cookieName],
    (value) => setCookie(cookieName, value),
    () => removeCookie(cookieName),
  ];
}
